import React from 'react';
import { Link } from 'react-router-dom';
import { Chip } from '@mui/material';
import { Button } from '../onyx/Button';
import { Panel } from '../onyx/Panel';
import { SectionHeader } from '../onyx/SectionHeader';

const STATUS_META = {
  pending: {
    label: 'Action needed',
    chipColor: 'warning',
    cta: 'Fill out form',
  },
  skipped: {
    label: 'Skipped',
    chipColor: 'default',
    cta: 'Fill out now',
  },
  completed: {
    label: 'Completed',
    chipColor: 'success',
    cta: 'Update answers',
  },
};

const KIND_LABELS = {
  onboarding_form: 'Onboarding form',
};

/**
 * Dashboard cards for aim-gated optional onboarding forms (Health Updates today;
 * more entries can be added from onboarding status ``optional_steps``).
 *
 * Pass ``statuses`` to place actionable cards in Needs attention and completed
 * cards under Your information without inventing a separate task system.
 */
export function OptionalStepsSection({ steps = [], statuses = null }) {
  const list = (Array.isArray(steps) ? steps.filter(Boolean) : []).filter((step) => {
    if (!statuses) return true;
    return statuses.includes(step.status);
  });
  if (list.length === 0) {
    return null;
  }

  return (
    <div className="optional-steps" data-testid="optional-steps-section">
      {list.map((step) => {
        const meta = STATUS_META[step.status] || STATUS_META.pending;
        const kindLabel = KIND_LABELS[step.kind] || KIND_LABELS.onboarding_form;
        const showCta = Boolean(step.can_open && step.path && step.status !== 'completed');
        const showUpdateLink = Boolean(
          step.can_open && step.path && step.status === 'completed',
        );
        return (
          <Panel
            key={step.key}
            className="dashboard-section"
            tone={step.status === 'pending' ? 'warning' : undefined}
            data-testid={`optional-step-${step.key}`}
          >
            <p className="optional-steps__kind">{kindLabel}</p>
            <SectionHeader
              title={step.label || step.key || 'Optional form'}
              description={step.description || null}
            />
            <div className="onyx-detail-list">
              <div className="onyx-detail-row">
                <span className="onyx-detail-label">Status</span>
                <span className="onyx-detail-value">
                  <Chip label={meta.label} color={meta.chipColor} size="small" />
                  {step.completed_at ? (
                    <>
                      {' '}
                      · {new Date(step.completed_at).toLocaleDateString()}
                    </>
                  ) : null}
                </span>
                {showCta ? (
                  <Button
                    type="button"
                    variant="primary"
                    component={Link}
                    to={step.path}
                  >
                    {meta.cta}
                  </Button>
                ) : null}
                {showUpdateLink ? (
                  <Button
                    type="button"
                    variant="ghost"
                    component={Link}
                    to={step.path}
                  >
                    {meta.cta}
                  </Button>
                ) : null}
              </div>
            </div>
          </Panel>
        );
      })}
    </div>
  );
}

export default OptionalStepsSection;
